import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import { sectionMissingSubsection } from './subsectionRule';

/**
 * Starting a discussion on wider screens: core's composer with core's DiscussionComposer
 * (fields, tags, editor, uploads, validation, submit and the redirect to the new discussion),
 * shown as a window in the middle of the page instead of a panel at the bottom
 * (.TpComposerModal, less/forum/composer.less). On phones the same form is full screen.
 * While it is a window:
 *   - × closes it (core's close: asks before dropping a title or text), so does Escape;
 *     minimise / full screen do not apply and the page is not padded for a bottom panel;
 *   - Tab stays inside it; the first field to fill gets the focus (section, then title).
 * Replies (in the page, inlineReply.tsx) and editing (the bottom panel) are not affected.
 */
const isWindow = state => app.screen() !== 'phone' && state.bodyMatches('flarum/forum/components/DiscussionComposer');
const focusable = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
export default function addComposerModal() {
  override('flarum/forum/components/Composer', 'view', function (original) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    const vnode = original(...args);
    if (vnode?.attrs && isWindow(this.state)) vnode.attrs.className += ' TpComposerModal';
    return vnode;
  });
  extend('flarum/forum/components/Composer', 'controlItems', function (items) {
    if (!isWindow(this.state)) return;
    for (const name of ['minimize', 'fullScreen', 'exitFullScreen']) if (items.has(name)) items.remove(name);
  });
  override('flarum/forum/components/Composer', 'updateBodyPadding', function (original) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    if (!isWindow(this.state)) return original(...args);
    $('#content').css({
      paddingBottom: 0
    });
  });

  // Focus stays in the window (Tab / Shift+Tab wrap around)
  extend('flarum/forum/components/Composer', 'oncreate', function () {
    this.element.addEventListener('keydown', e => {
      if (e.key !== 'Tab' || !isWindow(this.state) || this.state.position === 'minimized') return;
      const items = [...this.element.querySelectorAll(focusable)].filter(el => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  });

  // The first field to fill: the section picker while no subsection is chosen, then the title
  extend('flarum/forum/components/DiscussionComposer', 'oninit', function () {
    const composer = this.composer;
    this.constructor.focusOnSelector = () => {
      const tags = composer.fields.tags || [];
      return !tags.length || sectionMissingSubsection(tags) ? '.DiscussionComposer-changeTags' : '.DiscussionComposer-title';
    };
  });
}